import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PoExternalIdConflictDialogData {
  message: string;
}

@Component({
  selector: 'app-po-external-id-conflict-dialog',
  templateUrl: './po-external-id-conflict-dialog.component.html',
  styleUrls: ['./po-external-id-conflict-dialog.component.scss'],
})
export class PoExternalIdConflictDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<PoExternalIdConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: PoExternalIdConflictDialogData,
  ) {}

  goBack(): void {
    this.dialogRef.close(false);
  }

  submitAnyway(): void {
    this.dialogRef.close(true);
  }
}
